import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  setTokens: (access: string, refresh: string) => void;
  setAccessToken: (access: string) => void;
  clear: () => void;
}

/**
 * Tokens-only store. Дані поточного користувача (`/auth/me`) тримає TanStack Query
 * — кешуються по ключу та інвалідуються при зміні tenant'а / 2FA / зміні пароля.
 *
 * Persistence: localStorage. XSS — прийнятий ризик MVP. v2 розглянемо
 * httpOnly-cookie для refresh-токену (Architecture §8.5).
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      setTokens: (access, refresh) =>
        set({ accessToken: access, refreshToken: refresh }),
      setAccessToken: (access) => set({ accessToken: access }),
      clear: () => set({ accessToken: null, refreshToken: null }),
    }),
    { name: "kgu-auth" },
  ),
);
